import script from "./ManutOsAprovacaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutOsAprovacaoPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutOsAprovacaoPage.vue?vue&type=style&index=0&id=60d4f2b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d4f2b0"]])

export default __exports__